import { render, staticRenderFns } from "./ready.vue?vue&type=template&id=ef28af96&"
import script from "./ready.vue?vue&type=script&lang=js&"
export * from "./ready.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports